<template>
  <div>
    <main>
      <!-- Support PC Tablet -->
      <div
        v-if="windowWidth >= 600 && windowHeight >= 600"
        class="wrapper__Box__limitotp"
      >
        <div
          class="image-hearder"
          crm_at="image_hearder"
          :style="{ backgroundImage: 'url(' + storeinfo.image_header + ')' }"
        ></div>
        <div class="box_content">
          <div class="title">
            <div class="text-center text-header-verify" crm_at="text_header">
              {{ lbl.otp.title }}
            </div>
            <div class="text-center">
              <img
                class="logo-limitotp"
                crm_at="logo_limitotp"
                src="../../assets/images/handyman.svg"
                alt=""
              />
            </div>
            <div class="text-center">
              <div class="text-title" crm_at="text_title">
                {{ lbl.otp.cant_be_send }}
              </div>
              <div class="text-title-contact mt-2" crm_at="text_title_contact">
                {{ lbl.otp.please_contact_admin }}
              </div>
              <div class="text-title-ref mt-3" crm_at="text_title_ref">
                {{ lbl.otp.ref_otp }}
              </div>
            </div>
          </div>
          <div class="container-btn">
            <button
              :style="{
                backgroundColor: storeinfo.buttoncolor,
                border: storeinfo.buttoncolor,
                color: storeinfo.buttontextcolor,
              }"
              type="submit"
              value="Submit"
              crm_at="btn_limitotp"
              class="btn__limitotp"
              @click="submitRetry()"
            >
              {{ lbl.btn.retry }}
            </button>
          </div>
        </div>
      </div>

      <!-- Support Mobile -->
      <div v-else class="wrapper__Box__limitotp mb-5">
        <div class="row">
          <div class="col-12 p-0 m-0">
            <div
              class="header-image"
              :style="{
                'background-color': storeinfo.buttoncolor
                  ? storeinfo.buttoncolor
                  : '#fff',
              }"
            >
              <img
                class="header-logo"
                crm_at="header_logo"
                :src="storeinfo.image_logo"
                alt=""
              />
            </div>
          </div>
        </div>
        <div
          class="image-hearder"
          crm_at="image_hearder"
          :style="{ backgroundImage: 'url(' + storeinfo.image_header + ')' }"
        ></div>

        <div class="wrapper__limitotp__page">
          <div class="row title">
            <div class="col-12 text-center">
              <img
                class="logo-limitotp"
                crm_at="logo_limitotp"
                src="../../assets/images/handyman.svg"
                alt=""
              />
            </div>
            <div class="col-12 text-center">
              <div class="text-title" crm_at="text_title">
                {{ lbl.otp.cant_be_send }}
              </div>
              <div class="text-title-contact mt-3" crm_at="text_title_contact">
                {{ lbl.otp.please_contact_admin }}
              </div>
              <div class="text-title-ref mt-4" crm_at="text_title_ref">
                {{ lbl.otp.ref_otp }}
              </div>
            </div>
          </div>
        </div>
        <div class="wrapper__limitotp__page__button">
          <button
            :style="{
              backgroundColor: storeinfo.buttoncolor,
              border: storeinfo.buttoncolor,
              color: storeinfo.buttontextcolor,
            }"
            type="submit"
            value="Submit"
            crm_at="btn_limitotp"
            class="btn__limitotp"
            @click="submitRetry()"
          >
            {{ lbl.btn.retry }}
          </button>
        </div>
      </div>

      <AlertError
        :show="showError"
        :data="dataError"
        @changeError="ChangeError($event)"
      />
    </main>
  </div>
</template>

<script>
import _ from 'lodash'
import CommonMixin from '@/mixin/CommonMixin'
import AlertError from '@/components/Modal/AlertError'
import BzbsLogin from '@/core/Account/service/BzbsLogin.js'
import Account from '@/helper/AccountHelper.js'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'

export default {
  name: 'LimitOTP',
  components: {
    AlertError,
  },
  mixins: [CommonMixin, ResponsiveMixin],
  data() {
    return {
      storeinfo: {
        image_header: '',
        image_logo: '',
        businessName: '',
        buttoncolor: '',
        buttontextcolor: '',
        loginType: '',
      },
      dataError: {},
      showError: false,
      loginTypeList: [],
    }
  },
  created() {
    this.checklocalStorage().then(() => {
      this.init()
    })
  },
  methods: {
    init() {
      this.handleCheckAppId(this.$route)
      this.handleLanguage(true)
      this.handleLoading(false)
      this.getCustomerStore()
    },
    arrList(string) {
      var list = string.split(',')
      this.loginTypeList = list
      return list
    },
    getCustomerStore() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsLogin.getCustomerStore()
          .then(res => {
            this.genInfo(res)
            this.handleLoading(false)
            resolve(res.data)
          })
          .catch(error => {
            if (_.isEmpty(error.response)) {
              this.handleLoading(false)
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.connectionproblem,
              }
            }
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail:
                error.response.data.error.message ||
                this.lbl.error.connectionproblem,
            }
            this.handleLoading(false)
            resolve(error)
          })
      })
    },
    genInfo(res) {
      this.storeinfo.image_header = res.data.CoverUrl
      this.storeinfo.image_logo = res.data.LogoUrl
      this.storeinfo.businessName = res.data.BusinessName
      this.storeinfo.buttoncolor = res.data.ButtonColor
      this.storeinfo.buttontextcolor = res.data.ButtonTextColor
      this.storeinfo.loginType = res.data.loginType
      this.arrList(this.storeinfo.loginType)
    },
    submitRetry() {
      var fullPath = Account.getCache(
        'BzbsUser_' + Account.getCacheCustom('app_id'),
      ).fullPath
      console.log(fullPath)
      if (this.loginTypeList.includes('Device')) {
        if (this.loginTypeList.includes('Line')) {
          if (fullPath != null && fullPath != '') {
            window.location.href = fullPath
          } else {
            window.location.href = '/login'
          }
        }
        {
          window.location.href = '/landing/email'
        }
      } else if (this.loginTypeList.includes('Line')) {
        if (fullPath != null && fullPath != '') {
          window.location.href = fullPath
        } else {
          window.location.href = '/login'
        }
      } else {
        window.location.href = '/landing/email'
      }
    },

    //Error
    ChangeError(event) {
      this.showError = event
    },
  },
}
</script>

<style lang="scss">
@import '@/style/_mixin.scss';

.wrapper__Box__limitotp {
  .ant-input {
    border-radius: 10px !important;
    height: 50px;
    font-size: 16px;
  }

  .ant-input:focus {
    outline: -webkit-focus-ring-color auto 1px;
    -webkit-box-shadow: initial;
    box-shadow: initial;
  }

  ::placeholder {
    color: #999;
    opacity: 1;
  }

  .forgot_password {
    float: right;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    text-decoration: underline;
    color: #033a70;
  }

  .disable {
    border-color: #e5e5e5 !important;
    background-color: #e5e5e5 !important;
    color: #999 !important;
    pointer-events: none;
  }

  @mixin btn() {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    border-radius: 100px;
    font-size: 18px;
    height: 50px;
  }
  .btn__limitotp {
    @include btn();
    width: 100%;
    position: relative;
    font-weight: 500;
    margin-bottom: 40px;
    top: 10px;
    @include breakpoint-max(320) {
      width: 270px !important;
    }
  }
  .wrapper__limitotp__page__button {
    padding: 0 20px;
    position: fixed;
    bottom: 15px;
    width: 100%;
  }
  .active {
    opacity: 1;
    pointer-events: unset;
  }
  .icheck-primary {
    display: flex;
    gap: 8px;
    align-items: center;
  }
  .icheck-primary > input:first-child:checked + label::before {
    background-color: $color-radio-check !important;
    border-color: $color-radio-check !important;
  }
  .hr__style {
    margin: 0px 20px;
    border-top: 1px solid $color-input !important;
  }

  .wrapper__limitotp__page {
    &__content {
      padding: 0px 20px;
      .wrapper-title-limitotp {
        padding-top: 20px;
        padding-bottom: 20px;
        .wrapper-question {
          font-size: 16px;
        }
      }
    }

    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    margin-top: -50px;
    background-color: white;
    .title {
      padding: 10px;
      .text-title {
        font-size: 24px;
        font-weight: 700;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #212121;
      }

      .text-title-contact {
        font-size: 16px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        line-height: 1.5;
        color: #424242;
      }

      .text-title-ref {
        font-size: 14px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #afafaf;
      }
    }
    padding: 0px 5px;

    .label__checkbox {
      text-indent: 15px;
      position: absolute;
      top: -5px;
    }
    .radio-label {
      margin: 0 0 0 4px;
      font-size: 16px;
      letter-spacing: normal;
      text-align: left;
      color: $color-text-dark;
      white-space: nowrap;
      @include breakpoint-max(320) {
        font-size: 11px;
      }
    }
    .p-row {
      padding: 0px 0px 20px 0px !important;
      font-size: 16px;
    }
    .input__limitotp {
      text-indent: 10px;
      width: 100%;
      height: 50px;
      border-radius: 10px;
      border: solid 1px $color-input;
      background-color: #fff;
    }
    .select__limitotp {
      text-align: center;
      padding: 15px 0px 14px 0px;
      border-radius: 10px;
      border: solid 1px $color-input;
      width: 100%;
      background-color: #fff;
      @include breakpoint-max(320) {
        padding: 7px 0px 5px 0px !important;
      }
    }

    .checkbox__condition {
      width: 20px;
      height: 20px;
    }
  }

  .logo-limitotp {
    padding: 30px 0;
  }

  .serv ul {
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
  }

  .serv ul li {
    list-style: none;
    flex: 0 0 33.333333%;
  }

  .sub__title {
    font-size: 20px;
    color: #666;
    font-weight: 700;
  }

  .sub__title__verify {
    font-size: 17px;
  }

  .image-hearder {
    min-height: 257px;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .wrapper__bzb__logo {
    float: none;
  }
  .select__lang {
    margin: 22px;
  }
  @mixin error() {
    content: '*';
    width: 29px;
    height: 30px;
    top: 30px;
    font-size: 30px;
    position: absolute;
    display: inline-block;
    color: $color-error;
  }
  .error {
    &__col:after {
      @include error();

      right: 8px;
    }
    &__row:after {
      @include error();
      right: 8px;
      top: 40px;
    }
    &__select:after {
      @include error();
      top: 5px;
      text-indent: 1px;
    }
  }

  @media only screen and (orientation: landscape) {
    .wrapper__limitotp__page__button {
      padding-top: 30px;
      position: relative;
      bottom: 0px;
    }
  }
}
.wrapper__bzb__logo .bzb__logo_register {
  margin: 0;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 89px;
  height: 22px;
  margin-top: 40px;
  position: relative;
}

@media only screen and (min-device-width: 600px) and (min-device-height: 600px) {
  .wrapper__Box__limitotp {
    .image-hearder {
      height: 100vh;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .box_content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0;
      background-color: #fff;
      width: 35%;
      border-radius: 8px;
      padding: 10px 20px 20px;
      .text-header-verify {
        @include fontSize(24);
        @include fontWeight('medium');
      }
      .logo-limitotp {
        padding: 26px 0;
      }
      .title {
        .text-title {
          @include fontSize(24);
          @include fontWeight('medium');
        }
        .text-title-contact {
          @include fontSize(16);
          font-weight: normal;
        }
        .text-title-ref {
          @include fontSize(14);
          font-weight: normal;
        }
      }
    }

    .wrapper__limitotp__page__button {
      position: relative;
    }
    .btn__limitotp {
      top: unset;
      margin-bottom: unset;
      width: 70%;
    }
    .container-btn {
      padding: 30px 0 10px;
    }
  }
}
@media only screen and (min-device-width: 768px) {
  .wrapper__Box__limitotp {
    .box_content {
      width: 45%;
    }
  }
}
@media only screen and (min-device-width: 1280px) {
  .wrapper__Box__limitotp {
    .box_content {
      width: 35%;
    }
  }
}
</style>
